import { render } from "./px-level.vue?vue&type=template&id=7dc16f60&scoped=true&ts=true"
import script from "./px-level.vue?vue&type=script&lang=ts"
export * from "./px-level.vue?vue&type=script&lang=ts"

import "./px-level.vue?vue&type=style&index=0&id=7dc16f60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc16f60"]])

export default __exports__